import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

const EXCLUDED_DOMAINS = [
  'https://mappe.gse.it', // escludi chiamate a GSE
  environment.hasura.storage, // escludi lo storage
  // aggiungi qui altri domini se serve
];

export const langInterceptor: HttpInterceptorFn = (req, next) => {
  // se l’URL comincia con uno dei domini esclusi -> bypass
  const isExcluded = EXCLUDED_DOMAINS.some((domain) =>
    req.url.startsWith(domain),
  );

  if (isExcluded) {
    return next(req);
  }

  // altrimenti aggiungo l’header
  return next(
    req.clone({
      headers: req.headers.append(
        'x-hasura-lang',
        localStorage.getItem('lang') ?? 'it',
      ),
    }),
  );
};
